export function noedit (node) {
  node.componentInstance.notEditable = true
}
